export default __webpack_public_path__ + "static/z4-705cf9c9cc996d9d420a5916c1f7274e.svg";